import Wrapper from './wrapper';
import { rootActions, useAppSelector } from '../data/store';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const TopMenuMobile = () => {

    const dispatch = useDispatch();
    const isOpened = useAppSelector(store => store.root.isOpened);

    useEffect(() => {
        const $root = document.body;
        if(!$root) return;

        $root.classList.toggle('top-menu-m__opened', isOpened);
    }, [isOpened]);

    const toggle = () => {
        dispatch(
            rootActions.toggle({
                isOpened: !isOpened,
            })
        );
    };

    return (
        <>
            <button type="button" aria-label="Toggle Navigation" className="mx-5" onClick={ toggle }>
                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                     height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                     strokeLinecap="round" strokeLinejoin="round">
                    <title>Toggle Navigation</title>
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M4 6l16 0"></path>
                    <path d="M4 12l16 0"></path>
                    <path d="M4 18l16 0"></path>
                </svg>
            </button>

            <Wrapper />
        </>
    )
};

export default TopMenuMobile;